module.exports = __webpack_public_path__ + "img/crystal-rubber-lv0.27bb5a14.png";